import { RegisterResetpassService } from 'src/app/services/register-resetpass/register-resetpass.service';
import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { create_user } from 'src/app/services/auth/auth.model';
import { MenuService } from 'src/app/services/menu/menu.service';
import { AuthService } from '../../services/auth/auth.service';
import { SubSink } from 'subsink';
import { ToastController } from '@ionic/angular';
import { environment } from 'src/environments/environment';
import { PlatformService } from 'src/app/services/platform/platform.service';

@Component({
  selector: 'app-register',
  templateUrl: './register.page.html',
  styleUrls: ['./register.page.scss'],
})
export class RegisterPage implements OnInit {
  roles: any;
  registerForm: FormGroup;
  isLoading$: Observable<boolean>;
  subscription = new SubSink();
  showSpinner: boolean = false;
  frontend_url: string = environment.frontend_url;

  fb_message: string = '';
  hasFBError: boolean = false;

  response_message: string = '';
  isMobileDevice: boolean;

  constructor(
    private router: Router,
    public auth: AuthService,
    private fb: FormBuilder,
    private menu: MenuService,
    private register_resetpass: RegisterResetpassService,
    private toast: ToastController,
    private platform: PlatformService
  ) {
    this.menu.hideMenu();
    this.isMobileDevice = this.platform.isMobile();
  }

  //#region FORM GETTERS

  get account_type_id() {
    return this.registerForm.get('account_type_id');
  }
  get email() {
    return this.registerForm.get('email');
  }
  get user_name() {
    return this.registerForm.get('user_name');
  }
  get password() {
    return this.registerForm.get('password');
  }
  get first_name() {
    return this.registerForm.get('first_name');
  }
  get last_name() {
    return this.registerForm.get('last_name');
  }

  //#endregion FORM GETTERS

  ngOnInit() {
    this.readyRegisterForm();
    this.isLoading$ = this.auth.isLoading$;
    this.getUserAccountTypes();
  }

  readyRegisterForm() {
    this.registerForm = this.fb.group({
      account_type_id: [{value:'', disabled:this.isLoading$ }, Validators.required],
      email: [{value:'', disabled:this.isLoading$ }, [Validators.required, Validators.pattern('^[^@]+@([-\\w]+\\.)+[A-Za-z]{2,4}$')]],
      user_name: [{value:'', disabled:this.isLoading$ }, [Validators.required, Validators.pattern('^[a-zA-Z0-9_]+$')]],
      password: [{value:'', disabled:this.isLoading$ }, [Validators.required, Validators.minLength(6)]],
      first_name: [{value:'', disabled:this.isLoading$ }, [Validators.required, Validators.minLength(2), Validators.pattern(/\S+/)]],
      last_name: [{value:'', disabled:this.isLoading$ },  [Validators.required, Validators.minLength(2), Validators.pattern(/\S+/)]],
      policy_agreement: [{value:false, disabled:this.isLoading$ }, Validators.required]
    });
  }

  ionViewWillLeave(){
    this.subscription.unsubscribe();
  }

  getUserAccountTypes() {
    this.subscription.sink = this.register_resetpass.getAccountTypes().subscribe(
      (roles: any[]) => {
        this.roles = roles['data'];
      },
      (error) => console.log(error)
    );
  }

  privacyPolicyInBrowserOpen(){
    if (this.isMobileDevice) {
      window.open(this.frontend_url+'/privacy-policy', '_system', 'location=yes');    //New Window
    } else {
      window.open(this.frontend_url+'/privacy-policy', '_blank');   //New Tab
    }
  }

  termsConditionsInBrowserOpen(){
    if (this.isMobileDevice) {
      window.open(this.frontend_url+'/terms-conditions', '_system', 'location=yes');    //New Window
    } else {
      window.open(this.frontend_url+'/terms-conditions', '_blank');   //New Tab
    }
  }

  goToLogin() {
    this.router.navigate(['login'], { replaceUrl: true });
  }

  registerNewUser() {
    let user: create_user = this.registerForm.value;
    // console.log("resigister form data ==> ",user)
    this.showSpinner = true;
    // await this.auth.signup(user);

    // if(this.auth.fb_register_error){
    //   this.fb_message = this.auth.fb_register_error.message;
    // } else {
    //   this.fb_message = "User registered";
    //   await this.auth.loginWithEmailPassword(user.email, user.password);
    // }
          this.subscription.sink = this.register_resetpass
            .register(user)
            .subscribe(
              async (res:any) => {
                this.showSpinner = false;
                // this.hasFBError = false;
                // this.fb_message = 'User registered';
                this.response_message = "User registered successfully";
                this.presentSuccessToast(this.response_message);
                // console.log("Signup response ===> ",res);

                const email = res.user.email;
                const password = res.user.password;
                await this.auth.loginWithEmailPassword(email, password);
                // this.router.navigate(['profile-settings'], { replaceUrl: true });
              },
              (err:any) => {
                this.showSpinner = false;
                // this.response_message = err.error.message;
                // if (this.response_message === undefined) {
                //   this.response_message = "There was a problem creating your account, try again later."
                // }
                // this.presentErrorToast(this.response_message);
                let message = 'A problem occurred creating your account, try again later.';
                err.status === 400 ? this.presentErrorToast(err.error.message) : this.presentErrorToast(message);
              },
        // if (res.error) {
        //   this.hasFBError = true;
        //   this.fb_message = res.error;
        // } else {
        //   this.hasFBError = false;
        //   this.fb_message = 'User registered';
        //   await this.auth.loginWithEmailPassword(user.email, user.password);
        // }
        /* if (res.errorCode === undefined) {
          this.hasFBError = false;
          this.fb_message = "User registered";
          await this.auth.loginWithEmailPassword(user.email, user.password);
        } else if (res.errorCode === 'auth/email-already-in-use') {
          this.hasFBError = true;
          this.fb_message = "Email already in use";
        } else if (res.errorCode === 'auth/invalid-email') {
          this.hasFBError = true;
          this.fb_message = "Invalid email";
        } else if (res.errorCode === 'auth/weak-password') {
          this.hasFBError = true;
          this.fb_message = "Weak Password";
        } else {
          this.hasFBError = true;
          this.fb_message = "There was a problem creating your account, try again later.";
        } */


        // if (res.error) {
        //   const toast = await this.toast.create({
        //     header: 'Error',
        //     message: res.error,
        //     position: 'top',
        //     duration: 3000
        //   });
        //   await toast.present();
        // } else {
        //   const toast = await this.toast.create({
        //     header: 'Success',
        //     message: 'User registered successfully',
        //     position: 'top',
        //     duration: 3000,
        //     color: 'success'
        //   });
        //   await toast.present();

          // var loginToken = res.user.stsTokenManager.accessToken;
          // this.auth.verifyLoginToken(user, loginToken);
          // this.goToLogin();
        // }
            );
  }

  goToPrivacyPolicy() {
    this.router.navigate(['privacy-policy']);
  }

  goToTermsConditions() {
    this.router.navigate(['terms-conditions']);
  }

  async presentSuccessToast(res_message) {
    const toast = await this.toast.create({
      // header: 'Success',
      color: 'success',
      message: res_message,
      position: 'top',
      duration: 3000,
    });
    await toast.present();
  }

  async presentErrorToast(res_message) {
    const toast = await this.toast.create({
      header: 'Failed',
      color: 'danger',
      message: res_message,
      position: 'top',
      duration: 3000,
    });
    await toast.present();
  }

}
